<template>
    <div class="modal-wrapper" :class="{hide: !modals.greeting}" v-on:click.stop="hideModal">
        <div class="modal" v-on:click.stop>
            <div class="title">
                Welcome!
                <i class="material-icons pointer" @click="hideModal">close</i>
            </div>
            <div class="row">
                <span @click="openChat">How may we assist you today?</span>
            </div>
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"
import {MODAL, MODAL_FULLSCREEN} from '@/store/mutations.type'

export default {
    name: "GreetingModal",
    methods: {
        hideModal() {
            this.$store.commit(MODAL, {
                greeting: false
            })
        },
        openChat() {
            this.hideModal();
            this.$store.commit(MODAL, {
                fullscreen: true
            })
            this.$store.commit(MODAL_FULLSCREEN, {
                page: 'support'
            })

        }
    },
    computed: {
        ...mapGetters(['modals']),
    }
}
</script>

<style scoped>
.modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
}

.modal {
    width: 400px;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    background-color: var(--background-dark);
    padding: 25px;
    border: 1px solid var(--border);
    z-index: 1100;
}

.title {
    color: var(--white-to-black);
    font-weight: 600;
    font-size: 1.5em;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
}

.title i {
    font-size: 20px;
}

.row {
    overflow: hidden;
    align-items: stretch;
    flex-wrap: nowrap;
    font-size: 1.3em;
    font-weight: bold;
    span{
        text-decoration: none;
        transition: all 0.3s ease-in-out;
        cursor: pointer;
        &:hover{
            text-decoration: underline;
        }
    }

}
</style>